import moment from 'moment';
import { motion } from 'framer-motion';
import { Box, Typography, Card, Chip } from '@mui/material';

const EventCard = ({
    title,
    imageUrl,
    description,
    date,
    index = 0
}) => {
    return (
        <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-50px" }}
            transition={{ duration: 0.6, delay: index * 0.1, ease: "easeOut" }}
            style={{
                width: '100%',
                display: 'contents'
            }}
        >
            <Card
                sx={{
                    mb: { xs: 2, md: 3 },
                    flexShrink: 1,
                    cursor: 'pointer',
                    aspectRatio: 4 / 5,
                    overflow: 'hidden',
                    bgcolor: '#1a1a1a',
                    position: 'relative',
                    borderRadius: '25px',
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    backgroundImage: `url(${imageUrl})`,
                    border: '1px solid rgba(255,255,255,0.3)',
                    width: { xs: '95%', sm: "48%", md: "31%", xxl: "23%" },
                    transition: 'all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275)',
                    '&:hover': {
                        transform: 'translateY(-10px) scale(1.02)',
                        boxShadow: '0px 30px 30px rgba(255,255,255, 0.1)',
                    }
                }}
            >
                <Box
                    className="content-overlay"
                    sx={{
                        left: 0,
                        bottom: 0,
                        width: '100%',
                        height: '100%',
                        display: 'flex',
                        position: 'absolute',
                        flexDirection: 'column',
                        justifyContent: 'flex-end',
                        p: { xs: 4, md: 2, lg: 3 },
                        background: 'linear-gradient(to top, rgba(0,0,0,1) 0%, rgba(0,0,0,0.4) 50%, transparent 100%)',
                        transition: 'background 0.4s ease',
                    }}
                >
                    <Chip
                        label={moment(date).format('MMMM D, YYYY')}
                        size="small"
                        sx={{
                            top: 0,
                            right: 0,
                            color: 'white',
                            fontWeight: 800,
                            borderRadius: '8px',
                            position: 'absolute',
                            bgcolor: 'secondary.main',
                            mt: { xs: 3, md: 2, lg: 2 },
                            mr: { xs: 4, md: 2, lg: 3 },
                            fontSize: 'clamp(0.65rem, 2vw, 0.8rem)'
                        }}
                    />

                    <Typography
                        variant="h3"
                        sx={{
                            color: 'white',
                            fontFamily: 'Bebas Neue',
                            fontSize: {
                                xs: 'clamp(2rem, 8vw, 2.2rem)',
                                md: 'clamp(2rem, 2.9vw, 2.9rem)'
                            },
                            lineHeight: 1.1,
                            mb: 1,
                            letterSpacing: '1px',
                            display: '-webkit-box',
                            WebkitLineClamp: 1,
                            WebkitBoxOrient: 'vertical',
                            overflow: 'hidden',
                            textShadow: '0 4px 10px rgba(0,0,0,0.5)'
                        }}
                    >
                        {title}
                    </Typography>

                    <Typography
                        variant="body1"
                        sx={{
                            color: 'rgba(255,255,255,1)',
                            fontSize: {
                                xs: 'clamp(0.85rem, 3.5vw, 1rem)',
                                md: 'clamp(0.8rem, 1vw, 1rem)'
                            },
                            lineHeight: 1.6,
                            display: '-webkit-box',
                            WebkitLineClamp: 3,
                            WebkitBoxOrient: 'vertical',
                            overflow: 'hidden',
                        }}
                    >
                        {description}
                    </Typography>
                </Box>
            </Card>
        </motion.div>
    );
};

export default EventCard;
